import instance from "./axiosInstance";

interface AddTermsParams {
  accepted_at: string;
  accepted_by: string;
  acceptance_method: string;
  ip: string;
  browser: string;
  terms_version: string;
  tos_version: string;
  privacy_version: string;
  account_id: string;
  status: string;
  comments: string;
}

interface AddTermsResponse {
  ok: boolean;
  message: string;
  data?: any;
  status_code: number;
}

export const getBrowserInfo = (): string => {
  const userAgent = navigator.userAgent;
  let browserName = "Unknown";
  let osName = "Unknown";

  // Detect browser
  if (userAgent.includes("Firefox")) {
    browserName = "Firefox";
  } else if (userAgent.includes("Edg")) {
    browserName = "Edge";
  } else if (userAgent.includes("Chrome")) {
    browserName = "Chrome";
  } else if (userAgent.includes("Safari")) {
    browserName = "Safari";
  } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
    browserName = "Opera";
  }

  // Detect OS
  if (userAgent.includes("Windows")) {
    osName = "Windows";
  } else if (userAgent.includes("Mac")) {
    osName = "macOS";
  } else if (userAgent.includes("Linux")) {
    osName = "Linux";
  } else if (userAgent.includes("Android")) {
    osName = "Android";
  } else if (userAgent.includes("iOS") || userAgent.includes("iPhone") || userAgent.includes("iPad")) {
    osName = "iOS";
  }

  return `${browserName} on ${osName}`;
};

export const getCurrentUTCDateTime = (): string => {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, "0");
  const day = String(now.getUTCDate()).padStart(2, "0");
  const hours = String(now.getUTCHours()).padStart(2, "0");
  const minutes = String(now.getUTCMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes} UTC`;
};

export const addTerms = async (accessToken: string, params: AddTermsParams): Promise<AddTermsResponse> => {
  try {
    const response = await instance.post("/api/v1/add_terms", params, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error adding terms:", error);
    return {
      ok: false,
      message: error.response?.data?.message || "Failed to accept terms. Please try again.",
      status_code: error.response?.status || 500,
    };
  }
};
